import * as React from 'react';
import cn from 'clsx';
import './font/font.css';
import * as styles from './styles.css';

export interface ITextProps {
  children: React.ReactNode;
  color?: 'primary' | 'currentColor' | 'secondary' | 'error' | 'link';
  level?: number;
  tag?: 'span' | 'p' | 'div';
}

export const Body: React.FC<ITextProps> = props => {
  const { children, color = 'primary', level = 1, tag = 'span' } = props;

  const Tag = tag;
  const colorClassName = color === 'currentColor' ? 'current-color' : color;

  return <Tag className={cn(styles['text'], styles[colorClassName], styles[`level-${level}`])}>{children}</Tag>;
};

Body.displayName = 'Body';
